import React from 'react';
import { Text } from '@marvelapp/ui';
import { sizes } from './sizes';
export default function Label(_a) {
    var fontSize = _a.fontSize, size = _a.size, id = _a.id, isOptional = _a.isOptional, children = _a.children;
    var actualFontSize = fontSize !== undefined ? fontSize : sizes[size].fontSize;
    return (React.createElement(Text, { color: "licorice", display: "block", fontSize: actualFontSize, fontWeight: 500, htmlFor: id, mb: 2, tag: "label" },
        children,
        isOptional && (React.createElement(Text, { color: "slate", fontSize: actualFontSize - 1 || 1, fontWeight: 400, ml: 2, tag: "span" }, "(optional)"))));
}
